<template>
  <select-dict
    v-model="structureType"
    :selectList="structureTypes"
  ></select-dict>
</template>

<script setup lang="ts">
import { defineModel, computed, watch } from "vue";

import { useDictStore } from "@/stores/dictStore";
import { usePartitionStore } from "@/stores/new/partition.store";
import { useDoorsStore } from "@/stores/new/doors.store";
import { useOverdoorStore } from "@/stores/new/overdoor.store";

import SelectDict from "@/components/UI/SelectDict.vue";

const dictStore = useDictStore();
const partitionStore = usePartitionStore();
const activePartition = computed(() => partitionStore.activePartitions);

const doorsStore = useDoorsStore();
const overdoorStore = useOverdoorStore();

const structureTypes = dictStore.getStructureTypes("partition");
const structureType = defineModel<string>({ default: "" });

watch(
  () => structureType.value,
  () => {
    // remove overdoor from activePartition when partition type changes
    const activeOverdoorId = activePartition.value?.getActiveOverdoor()?.id;
    activePartition.value?.removeComponent(activeOverdoorId, "overdoor");
    overdoorStore.$reset();

    // remove door from activePartition when partition type changes
    const activeDoorId = activePartition.value?.getActiveDoor()?.id;
    activePartition.value?.removeComponent(activeDoorId, "door");
    doorsStore.$reset();
  },
  {
    deep: true,
  },
);
</script>

<style lang="scss" scoped></style>
